import { useTranslation } from 'next-i18next';

import { Badge, Box, Flex, Heading, Link, Separator, Text } from '@chakra-ui/react';

import { ContactData } from '@nocowanie/core/consts';
import { Avatar } from '@nocowanie/common-ui/components/atoms/avatar';
import { IconsLinear } from '@nocowanie/icons/linear';

import { environment } from '@app/environments/environment';
import * as accommodationStaticSlice from '@app/state/slices/accommodation-static.slice';
import { useAppSelector } from '@app/state/state';

export const OfferManager = () => {
    const { t } = useTranslation('accommodation');
    const { GFX_SERVER } = environment;
    const { ratingCount } = useAppSelector(accommodationStaticSlice.selectors.selectReviewsData);

    return (
        <>
            {!ratingCount ? (
                <Flex
                    direction={{ base: 'column', lg: 'row-reverse' }}
                    justify={{ base: 'flex-start', lg: 'space-between' }}
                    align={'flex-start'}
                >
                    <Badge variant={'subtle'} colorPalette="secondary" data-testid="no-rating">
                        {t('basicInformation.badges.newAccommodation')}
                    </Badge>
                    <Heading
                        as={'h3'}
                        fontSize={'lg'}
                        mt={{ base: 4, lg: 0 }}
                        mb={4}
                        dangerouslySetInnerHTML={{ __html: t('offerManager.headingText') }}
                    />
                </Flex>
            ) : null}
            <Flex alignItems={'center'} mb={5}>
                <Avatar
                    src={`${GFX_SERVER}/accommodation/offer-manager/offer-manager.jpg`}
                    width={16}
                    height={16}
                    mr={{
                        base: 3,
                        md: 4,
                    }}
                />
                <Flex
                    direction={{
                        base: 'column',
                        lg: 'row',
                    }}
                    flex={'1'}
                    gap={2}
                    justifyContent={{
                        md: 'space-between',
                    }}
                >
                    <Box
                        fontSize={{
                            base: 'sm',
                            md: 'md',
                        }}
                        gap={{
                            lg: 1,
                        }}
                    >
                        <Text fontWeight={'bold'}>{t('offerManager.title')}</Text>
                        <Text> {t('offerManager.subTitle')}</Text>
                    </Box>
                    <Flex
                        direction={'column'}
                        gap={{
                            lg: 1,
                        }}
                    >
                        <Text hideBelow="xl">{t('offerManager.contactLabel')}</Text>
                        <Flex flexWrap={'wrap'}>
                            <Link
                                href={`tel:${ContactData.phneNumber}`}
                                fontSize={{
                                    base: 'xs',
                                    md: 'sm',
                                }}
                                mr={6}
                                colorPalette={'gray'}
                                variant={'plain'}
                            >
                                <IconsLinear.Call2 size={'xs'} mr={2} />
                                {ContactData.phneNumber}
                            </Link>
                            <Link
                                href={`mailto:${ContactData.email}`}
                                fontSize={{
                                    base: 'xs',
                                    md: 'sm',
                                }}
                                colorPalette={'gray'}
                                variant={'plain'}
                            >
                                <IconsLinear.Mail size={'xs'} mr={2} />
                                {ContactData.email}
                            </Link>
                        </Flex>
                    </Flex>
                </Flex>
            </Flex>
            <Separator orientation="horizontal" />
        </>
    );
};
